import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import { Fragment, FunctionComponent, memo } from "react";

import { IProps } from "./query-history-title-dates.types";
import "./query-history-title-dates.scss";

/**
 * Show the range of dates in a thread for the title. If there is only one date or all the interactions in a thread
 * have happened on the same day, then only one date is shown.
 * @param firstDateTime Earliest date in the thread.
 * @param lastDateTime  Last date in the thread.
 * @returns             Date display.
 */
const QueryHistoryTitleDates: FunctionComponent<IProps> = ({ firstDateTime, lastDateTime }) => {
    return (
        <Fragment>
            {format(firstDateTime, "dd/MM/yy")}
            {!isSameDay(firstDateTime, lastDateTime) && <Fragment> to {format(lastDateTime, "dd/MM/yy")}</Fragment>}
        </Fragment>
    );
};

export default memo(QueryHistoryTitleDates);
